import React from 'react';
import { Button } from './ui/button';
import { Bookmark, BookmarkSimple } from '@phosphor-icons/react';
import { useBookmarks } from '../context/BookmarksContext';

/**
 * Star/bookmark toggle button for a single sanction.
 * - `variant="icon"` (default): small icon-only button for list rows
 * - `variant="full"`: larger button with label, for the detail page
 */
export const BookmarkButton = ({ sanctionId, variant = 'icon', className = '' }) => {
  const { isBookmarked, toggle } = useBookmarks();
  const bookmarked = isBookmarked(sanctionId);

  const handleClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    toggle(sanctionId);
  };

  if (variant === 'full') {
    return (
      <Button
        type="button"
        variant={bookmarked ? 'default' : 'outline'}
        onClick={handleClick}
        className={`rounded-sm ${className}`}
        aria-pressed={bookmarked}
        aria-label={bookmarked ? 'Remove bookmark' : 'Add bookmark'}
        data-testid={`bookmark-toggle-${sanctionId}`}
      >
        {bookmarked ? (
          <Bookmark weight="fill" className="mr-2 h-4 w-4" />
        ) : (
          <BookmarkSimple weight="duotone" className="mr-2 h-4 w-4" />
        )}
        {bookmarked ? 'Saved' : 'Save'}
      </Button>
    );
  }

  return (
    <button
      type="button"
      onClick={handleClick}
      className={`p-1.5 text-muted-foreground hover:text-primary transition-colors ${bookmarked ? 'text-primary' : ''} ${className}`}
      aria-pressed={bookmarked}
      aria-label={bookmarked ? 'Remove bookmark' : 'Add bookmark'}
      data-testid={`bookmark-toggle-${sanctionId}`}
    >
      {bookmarked ? (
        <Bookmark weight="fill" className="h-5 w-5" />
      ) : (
        <BookmarkSimple weight="duotone" className="h-5 w-5" />
      )}
    </button>
  );
};
